import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module'; 
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { TreeModule } from 'angular-tree-component';
import { AngularSplitModule } from 'angular-split';
import { OverviewComponent } from './overview/overview.component';
import { ReleaseComponent } from './release/release.component';
import { LicenseComponent } from './license/license.component';
import { SamplesComponent } from './samples/samples.component';
import { ReferenceComponent } from './reference/reference.component';
import { SearchComponent } from './search/search.component';
import { AceEditorModule } from 'ng2-ace-editor';
import { CodeviewerComponent } from './codeviewer/codeviewer/codeviewer.component';
import { LoadingPopupComponent } from './loading/loading-popup.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ScriptGeneratorComponent } from './script-generator/script-generator.component';
import { MarkdownModule } from 'ngx-markdown';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTreeModule, MatNestedTreeNode} from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input'

@NgModule({
	declarations: [
		AppComponent,
        OverviewComponent,
        ReleaseComponent,
		LicenseComponent,
		SamplesComponent,
		ReferenceComponent,
		CodeviewerComponent,
		SearchComponent,
		LoadingPopupComponent,
		ScriptGeneratorComponent
	],
	imports: [
		BrowserModule,
		FormsModule,
		AppRoutingModule,
		AceEditorModule,
		TreeModule.forRoot(),
        AngularSplitModule.forRoot(),
        MarkdownModule.forRoot(),
        HttpClientModule,
        BrowserAnimationsModule,
		MatTreeModule,
		MatIconModule,
		MatButtonModule,
		MatFormFieldModule,
		MatInputModule
	],
	providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
	bootstrap: [AppComponent]
})
export class AppModule { }
